import { withTenant } from '@/lib/tenantHeaders';
import { apiFetch } from '@/lib/apiFetch';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3000';


/**
 * EnvÃ­a invitaciones de cotizaciÃ³n a N proveedores.
 * @param {string} airRequestId
 * @param {string[]} providerIds
 * @param {string} replyTo - email del usuario logueado (se usa como Reply-To)
 * @param {string} [notes]
 */
export async function sendProviderInvitations({
  airRequestId,
  providerIds,
  replyTo,
  notes,
}) {
  const res = await apiFetch(`${API_BASE}/provider-invitations/send`, {
    method: 'POST',
    headers: withTenant({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ airRequestId, providerIds, replyTo, notes }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body?.message || 'No se pudieron enviar las invitaciones');
  }
  return res.json();
}

/**
 * Lista las invitaciones de una solicitud.
 */
export async function fetchInvitationsByAirRequest(airRequestId) {
  const res = await apiFetch(
    `${API_BASE}/provider-invitations/air-request/${airRequestId}`,
    { headers: withTenant() },
  );
  if (!res.ok) throw new Error('No se pudieron cargar las invitaciones');
  return res.json();
}
